import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { ButtonComponent } from './button/index';
import { CtaButtonComponent } from './cta-button/cta-button.component';
import { LoaderModule } from '../loader';

@NgModule({
  declarations: [ButtonComponent, CtaButtonComponent],
  imports: [CommonModule, UiTranslateModule, IconsModule, LoaderModule],
  exports: [ButtonComponent, CtaButtonComponent],
  providers: [],
})
export class ButtonModule {}
